import ol from "openlayers";
// @ts-ignore
import proj4 from "proj4";
window.ol = ol;
// @ts-ignore
window.proj4 = proj4;

// eslint-disable-next-line import/first
import Client from "swecomap/src/swecomap/Client";

const swecomap = {
  client: null as null | Client,
};

export const setClient = (client: Client) => {
  swecomap.client = client;
  //Hack to remove overlay leftovers that is blocking map interaction
  document!.querySelector("body")!.className = "";
};

export const disableAutoselect = () => {
  swecomap.client?.autoSelection?.deactivate();
};

export const enableAutoselect = () => {
  swecomap.client?.autoSelection?.activate();
};

const disableInteraction = (interactionClass: any) => {
  const map = swecomap.client!.map;
  const interactions = map.getInteractions().getArray();
  const pinchRotateInteraction = interactions.filter((interaction) => {
    return interaction instanceof interactionClass;
  })[0];

  pinchRotateInteraction.setActive(false);
};

export const disableRotate = () => disableInteraction(ol.interaction.PinchRotate);

export const disableDoubleClickZoom = () => disableInteraction(ol.interaction.DoubleClickZoom);

const Swecomap = {
  setClient,
  disableAutoselect,
  enableAutoselect,
  disableRotate,
  disableDoubleClickZoom,
};
export default Swecomap;
